import React, { useMemo } from 'react';
import { AddressDraft } from '../AddressDraft/index.js';
import { ACCOUNT_ORDER_STATUS, getCurrencyIcons } from '../../../../utils/enums';
import { useTranslation } from 'react-i18next';
import { getDepotByIdMap, getLabelWithMetric } from '../../../../services/restaurant';
import { DeliveryTimeDraft } from '../DeliveryTimeDraftOrder';
import { useGetDeliveryInfo } from '../../../../utils/order';
import { NotesDraft } from '../NotesDraft/index.js';
import { StatusDraft } from '../StatusDraft/index.js';
import { OrderDateDraft } from '../OrderDateDraft/index.js';
import IconButton from '../../IconButton/IconButton.jsx';
import { Button, Dropdown } from 'antd';
import classNames from 'classnames';
import { isRTL } from '../../../../services/userModel.js';
import { useHistory } from "react-router";
import OrderStateControl from '../../OrderStateControl/OrderStateControl.jsx';
import { fixedNumber } from '../../../../utils/math-util.js';

export const DeliveryDraftOrder = ({ order, estimatedPriceInfo, onClickCreate, onClickDelete, showTime, showEditOrder, showAssociate, onAssociate, showExtraButton, onChangeState }) => {
    const history = useHistory();
    const { t } = useTranslation();

    const depot = useMemo(() => {
        return getDepotByIdMap(order.depot_id);
    }, [order.depot_id]);

    const deliveryInfo = useGetDeliveryInfo({
        pickupEta: order.pickup_eta,
        dropOffEta: order.dropoff_eta,
        status: order.status,
        deliveryDatetime: order.delivery_datetime,
        actualDeliveryDatetime: order.actual_delivery_datetime,
        t
    });

    const handleMenuClick = (e) => {
        if (e.key === 'create') {
            return onClickCreate();
        }
        if (e.key === 'edit') {
            return history.push(`/edit-order?orderId=${order.id}`);
        }
        if (e.key === 'associate') {
            return onAssociate(order.id);
        }
        onClickDelete();
    };

    const menuProps = {
        items: [{
            label: t('dashboard.orders.DISBAND_GROUP_ORDER'),
            key: 'disband',
            icon: <IconButton isIcon iconName={'disband-order'} />
        },
        {
            label: t('draft.createPickup'),
            key: 'create',
            icon: <IconButton isIcon iconName={'add-pickup'} />
        }]
            .concat(showEditOrder ? {
                label: t('dashboard.orders.EDIT_ORDER_LABEL'),
                key: 'edit',
                icon: <IconButton isIcon iconName={'editItem'} />
            } : null)
            .concat(showAssociate ? {
                label: t('dashboard.orders.ASSOCIATE_LABEL'),
                key: 'associate',
                icon: <IconButton isIcon iconName={'courierActionIcon'} />
            } : null)
            .filter(Boolean),
        className: classNames("draftMenuItem", { rtl: isRTL() }),
        onClick: handleMenuClick,
    };

    return (
        <div className={classNames("deliveryDraftOrder", { showExtraButton })}>
            <div className="deliveryDraftOrderBody">
                <div className="sectionItem headerSection">
                    <OrderDateDraft
                        deliveryDatetime={order.delivery_datetime}
                        deliveryStrategy={order.delivery_strategy}
                        creationDatetime={order.creation_datetime}
                        readinessTime={order.readiness_time}
                        cooking={order.cooking}
                        isCookingReady={!!order.status && order.status >= ACCOUNT_ORDER_STATUS.ready}
                        cookingTime={order.cooking_time}
                        isMultiselectMode={false}
                        isAddedToCheckList={false}
                    />
                    <StatusDraft
                        deliveryType={order.delivery_type}
                        processStep={order.process_step}
                        readinessTime={order.readiness_time}
                        isCookingReady={!!order.status && order.status >= ACCOUNT_ORDER_STATUS.ready}
                        hasCourier={true}
                        extendedStatus={order.extended_status}
                        status={order.status} />
                </div>

                <AddressDraft
                    sequenceId={order.sequence_id}
                    depotName={depot?.name}
                    address={order.address}
                    organization={order.organization}
                    city={order.city}
                />

                <NotesDraft
                    orderSource={order.order_source}
                    addressNotes={order.address_notes}
                    comment={order.comment}
                    isExtraSize={order.is_extrasize}
                    isHighPriority={order.is_high_priority}
                />

                {showTime && (
                    <DeliveryTimeDraft
                        deliveryInfo={deliveryInfo}
                        pickupEta={order.pickup_eta}
                        pickupTime={order.pickup_time}
                        dropOffEta={order.dropoff_eta}
                        deliveryDatetime={order.delivery_datetime}
                    />
                )}

                {estimatedPriceInfo || estimatedPriceInfo === 0 ? (
                    <div className={classNames('infoItemFee')}>
                        <span>
                            {(order?.ridingDistance || order?.riding_distance) &&
                                <span>
                                    {parseFloat(((order?.ridingDistance || order?.riding_distance) / 1000).toFixed(2))}{' '}
                                    {t(getLabelWithMetric('dashboard.orders.DISTANCE_LABEL'))},
                                </span>
                            }{' '}
                            {t('dashboard.orders.FEE')}: {fixedNumber(estimatedPriceInfo, 2)}{getCurrencyIcons(order.currency)}
                            {!!(order.courierFeeBidIncrease || order.courier_fee_bid_increase) && ` +${fixedNumber((order.courierFeeBidIncrease || order.courier_fee_bid_increase) * 100, 2)}%`}
                        </span>
                    </div>
                ) : ((order?.ridingDistance || order?.riding_distance) &&
                    <div className={classNames('infoItemFee')}>
                        <span>
                            {parseFloat(((order?.ridingDistance || order?.riding_distance) / 1000).toFixed(2))}{' '}
                            {t(getLabelWithMetric('dashboard.orders.DISTANCE_LABEL'))}
                        </span>
                    </div>
                )}
            </div>

            <div className="contextMenuDort" draggable={false} onPointerDown={(e) => e.stopPropagation()}>
                <Dropdown menu={menuProps} placement="bottomRight">
                    <Button icon={<IconButton isIcon iconName={'menu-dots'} />} />
                </Dropdown>

                {showExtraButton && (
                    <OrderStateControl order={{ ...order, groupId: order.courier_id, state: order.status }} hideAssociate={true} onChangeState={onChangeState} />
                )}
            </div>

        </div>
    )
}